import { render, staticRenderFns } from "./InstagramEdit.vue?vue&type=template&id=797d2106&scoped=true&"
import script from "./InstagramEdit.vue?vue&type=script&lang=js&"
export * from "./InstagramEdit.vue?vue&type=script&lang=js&"
import style0 from "./InstagramEdit.vue?vue&type=style&index=0&id=797d2106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d2106",
  null
  
)

export default component.exports